import { render, staticRenderFns } from "./department-alias.vue?vue&type=template&id=3c94a31d&scoped=true&"
import script from "./department-alias.vue?vue&type=script&lang=js&"
export * from "./department-alias.vue?vue&type=script&lang=js&"
import style0 from "./department-alias.vue?vue&type=style&index=0&id=3c94a31d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94a31d",
  null
  
)

export default component.exports